import React, { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import {
	ExpertCard,
	expertsAtom,
	IExpertFilterModel,
	ISelectListItem,
} from '../../functions/_exports'
import { useSearchParams } from 'react-router-dom'
import Select, { MultiValue } from 'react-select'

export interface PageProps {
	filter: IExpertFilterModel
}

const ExpertsDefaultView = ({ filter }: PageProps) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const [experts] = useAtom(expertsAtom)

	const [filteredExperts, setFilteredExperts] = useState(experts)
	const [filteredExpertsToShow, setFilteredExpertsToShow] = useState(experts)

	const [page, setPage] = useState(1)
	const [pageCount, setPageCount] = useState(Math.ceil(filteredExperts.length / 10))

	useEffect(() => {
		const getFilteredExperts = filterExperts()
		setFilteredExperts(getFilteredExperts)
		setPageCount(Math.ceil(getFilteredExperts.length / 10))

		var pageSearch = parseInt(searchParams.get('page') || '1')
		setPage(pageSearch)
	}, [])

	useEffect(() => {
		setPageCount(Math.ceil(filteredExperts.length / 10))

		const current = page - 1
		setFilteredExpertsToShow(filteredExperts.slice(current * 10, current * 10 + 10))
	}, [filteredExperts])

	useEffect(() => {
		if (page === 1) {
			searchParams.delete('page')
			setSearchParams(searchParams)
		} else {
			searchParams.set('page', page.toString())
			setSearchParams(searchParams)
		}

		setFilteredExpertsToShow(filterExperts().slice((page - 1) * 10, (page - 1) * 10 + 10))
	}, [page])

	const filterExperts = () => {
		const surnameSearch = searchParams.get('priezvisko')
		const typesSearch = searchParams.get('typ')?.split(',')
		const localitiesSearch = searchParams.get('lokality')?.split(',')
		const expertisesSearch = searchParams.get('expertiza')?.split(',')

		var tempExperts = experts

		if (surnameSearch && surnameSearch.length >= 3) {
			tempExperts = tempExperts.filter((temp) =>
				temp.surname
					.toLocaleLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.includes(
						surnameSearch
							.toLowerCase()
							.normalize('NFD')
							.replace(/[\u0300-\u036f]/g, '')
					)
			)
		}

		if (typesSearch && typesSearch.length > 0) {
			tempExperts = tempExperts.filter((expert) =>
				expert.expertTypeList.some((type) => typesSearch.includes(type.value))
			)
		}

		if (expertisesSearch && expertisesSearch.length > 0) {
			tempExperts = tempExperts.filter((expert) =>
				expert.expertiseList.some((expertise) => expertisesSearch.includes(expertise.value))
			)
		}

		if (localitiesSearch && localitiesSearch.length > 0) {
			//if (localitiesSearch.includes('cele-slovensko')) {
			//} else {
			tempExperts = tempExperts.filter(
				(expert) =>
					expert.preferredLocalityList.some((locality) =>
						localitiesSearch.includes(locality.value)
					) ||
					expert.preferredLocalityList.some((locality) => locality.value == 'cele-slovensko')
			)
			//}
		}

		return tempExperts
	}

	const getOptions = (items: ISelectListItem[]) => {
		const temp: any[] = []
		items.forEach((item) => {
			temp.push({ label: item.text, value: item.value })
		})

		return temp
	}

	const createSearch = (
		search: string,
		items:
			| MultiValue<{
					value: string
					label: string
			  }>
			| undefined
	) => {
		if (!items) {
			return
		}
		let tempString = ''
		items.forEach((item: any, index: number) => {
			if (index < items.length - 1) {
				tempString += item.value + ','
			} else {
				tempString += item.value
			}
		})

		if (tempString == '') {
			searchParams.delete(search)
			setSearchParams(searchParams)
		} else {
			searchParams.delete('page')
			setPage(1)
			searchParams.set(search, tempString)
			setSearchParams(searchParams)
		}
	}

	const parseSearch = (search: string) => {
		return searchParams
			.get(search)
			?.split(',')
			.map((item) => {
				switch (search) {
					case 'typ':
						var foundItem = filter.expertTypeList.find((type) => type.value === item)
						if (foundItem) {
							return { value: foundItem.value, label: foundItem.text }
						}
					case 'expertiza':
						var foundItem = filter.expertiseList.find((expertise) => expertise.value === item)
						if (foundItem) {
							return { value: foundItem.value, label: foundItem.text }
						}
					case 'lokality':
						var foundItem = filter.preferredLocalityList.find(
							(locality) => locality.value === item
						)
						if (foundItem) {
							return { value: foundItem.value, label: foundItem.text }
						}
				}
			})
	}

	const filterElement = (
		<div id="filter" className="col-md-12">
			<form asp-action="Index" method="get">
				<div
					className="grid grid-cols-4 gap-x-5 text-center"
					style={{ width: '70%', margin: 'auto' }}
				>
					<div
						style={{
							gridColumn: 'span  3/span 2',
							display: 'flex',
							padding: '15px 35px 15px 5px',
						}}
					>
						<label asp-for="Filter.Surname" className="idsk-label-custom">
							Priezvisko:
						</label>
						<input
							type="text"
							className="govuk-input"
							style={{ width: '100%' }}
							onChange={(e) => {
								searchParams.set('priezvisko', e.target.value)
								setSearchParams(searchParams)
								setFilteredExperts(filterExperts())
							}}
						/>
					</div>
				</div>

				<div className="grid grid-cols-3 gap-x-5">
					<div>
						<button
							className="idsk-search-results__link-panel-button"
							type="button"
							style={{ borderBottom: 'none' }}
						>
							<span style={{ fontSize: '19px' }}>Typ experta:</span>
						</button>
						<div style={{ paddingLeft: '0px' }}>
							<Select
								value={parseSearch('typ')}
								isMulti
								name="typ"
								options={getOptions(filter.expertTypeList)}
								placeholder="Vyberte..."
								closeMenuOnSelect={false}
								noOptionsMessage={() => 'Žiadne ďalšie možnosti'}
								onChange={(items: any) => {
									createSearch('typ', items)
									setFilteredExperts(filterExperts())
								}}
							/>
						</div>
					</div>
					<div>
						<button
							className="idsk-search-results__link-panel-button"
							type="button"
							style={{ borderBottom: 'none' }}
						>
							<span style={{ fontSize: '19px' }}>Expertíza:</span>
						</button>
						<div style={{ paddingLeft: '0px' }}>
							<Select
								value={parseSearch('expertiza')}
								isMulti
								name="expertiza"
								options={getOptions(filter.expertiseList)}
								placeholder="Vyberte..."
								closeMenuOnSelect={false}
								noOptionsMessage={() => 'Žiadne ďalšie možnosti'}
								onChange={(items: any) => {
									createSearch('expertiza', items)

									setFilteredExperts(filterExperts())
								}}
							/>
						</div>
					</div>
					<div>
						<button
							className="idsk-search-results__link-panel-button"
							type="button"
							style={{ borderBottom: 'none' }}
						>
							<span style={{ fontSize: '19px' }}>Preferované lokality:</span>
						</button>
						<div style={{ paddingLeft: '0px' }}>
							<Select
								value={parseSearch('lokality')}
								isMulti
								name="lokality"
								options={getOptions(filter.preferredLocalityList)}
								placeholder="Vyberte..."
								closeMenuOnSelect={false}
								noOptionsMessage={() => 'Žiadne ďalšie možnosti'}
								onChange={(items: any) => {
									createSearch('lokality', items)
									setFilteredExperts(filterExperts())
								}}
							/>
						</div>
					</div>
				</div>
			</form>
		</div>
	)

	const pagination = () => {
		return (
			<div className="blog-pagination">
				<div className="text-center mt-5 events-header__arrows">
					{page > 1 && (
						<a
							className="govuk-link"
							onClick={() => {
								setPage(page - 1)
							}}
						>
							<i className="fa fa-chevron-left"></i>
						</a>
					)}

					<h3 className="mt-0">
						Strana {page} z {pageCount}
					</h3>

					{pageCount > page && (
						<a
							className="govuk-link"
							onClick={() => {
								setPage(page + 1)
							}}
						>
							<i className="fa fa-chevron-right"></i>
						</a>
					)}
				</div>
			</div>
		)
	}

	return (
		<>
			{filterElement}
			<div className="col-md-12">
				<div className="contact">
					<div className="organization grid grid-cols-2 gap-x-5">
						{filteredExpertsToShow.map((expert) => {
							return <ExpertCard expert={expert} key={expert.name + ' ' + expert.surname} />
						})}
					</div>
				</div>
			</div>
			{pagination()}
		</>
	)
}

export default ExpertsDefaultView
